import React from 'react';
import { Modal, Button, Table, Badge, ProgressBar, Spinner, Row, Col } from 'react-bootstrap';

const ModalProgresoBorrado = ({ progresoBorrado, setProgresoBorrado }) => {
    return (
        <Modal 
            show={Boolean(progresoBorrado.show)} 
            onHide={() => setProgresoBorrado(prev => ({ ...prev, show: false }))} 
            centered 
            size="lg"
            backdrop="static"
        >
            <Modal.Header closeButton className="bg-100 border-bottom border-300">
                <Modal.Title className="fs-0 fw-bold d-flex align-items-center gap-2 text-900">
                    {progresoBorrado.enProgreso ? (
                        <>
                            <Spinner animation="border" size="sm" variant="primary" />
                            <span>Ejecutando Borrado de Bases de Datos</span>
                        </>
                    ) : (
                        <>
                            <i className="fas fa-check-circle text-success fs-1"></i>
                            <span>Mantenimiento de Borrado Finalizado</span>
                        </>
                    )}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="py-3 bg-card">
                {/* Barra de Progreso Principal */}
                <div className="mb-3">
                    <div className="d-flex justify-content-between align-items-center mb-1">
                        <span className="fs--1 fw-semi-bold text-700">
                            {progresoBorrado.totalEmpresas > 0 
                                ? `Procesando: ${progresoBorrado.procesadas} de ${progresoBorrado.totalEmpresas} empresas`
                                : (progresoBorrado.enProgreso ? 'Iniciando proceso de borrado...' : 'Sin empresas procesadas')}
                        </span>
                        <span className="fw-bold fs--1 text-primary">
                            {progresoBorrado.totalEmpresas > 0 
                                ? `${Math.round((progresoBorrado.procesadas / progresoBorrado.totalEmpresas) * 100)}%`
                                : (progresoBorrado.enProgreso ? '0%' : '100%')}
                        </span>
                    </div>
                    <ProgressBar 
                        animated={progresoBorrado.enProgreso} 
                        striped={progresoBorrado.enProgreso}
                        variant={progresoBorrado.fallidas > 0 ? "warning" : "success"}
                        now={progresoBorrado.totalEmpresas > 0 
                            ? Math.round((progresoBorrado.procesadas / progresoBorrado.totalEmpresas) * 100) 
                            : (progresoBorrado.enProgreso ? 10 : 100)} 
                        style={{ height: '14px', borderRadius: '7px' }}
                    />
                </div>

                {/* Tarjetas resumen con soporte modo oscuro */}
                <Row className="g-2 mb-3">
                    <Col xs={4}>
                        <div className="p-2 border border-300 rounded text-center bg-100 shadow-sm">
                            <div className="text-700 fs--2">Total a Borrar</div>
                            <div className="fs-1 fw-bold text-900">{progresoBorrado.totalEmpresas}</div>
                        </div>
                    </Col>
                    <Col xs={4}>
                        <div className="p-2 border border-300 rounded text-center bg-100 shadow-sm">
                            <div className="text-700 fs--2">Exitosas</div>
                            <div className="fs-1 fw-bold text-success">{progresoBorrado.exitosas}</div>
                        </div>
                    </Col>
                    <Col xs={4}>
                        <div className="p-2 border border-300 rounded text-center bg-100 shadow-sm">
                            <div className="text-700 fs--2">Omitidas / Con Error</div>
                            <div className="fs-1 fw-bold text-danger">{progresoBorrado.fallidas}</div>
                        </div>
                    </Col>
                </Row>

                {/* Lista de las empresas procesadas */}
                <div className="border border-300 rounded overflow-hidden">
                    <div className="bg-100 px-3 py-2 border-bottom border-300 d-flex justify-content-between align-items-center">
                        <span className="fw-semi-bold fs--1 text-800">Empresas en este ciclo de borrado</span>
                        <Badge bg="secondary" className="fs--2">{progresoBorrado.empresas.length} empresas</Badge>
                    </div>
                    <div className="table-responsive" style={{ maxHeight: '280px' }}>
                        <Table size="sm" striped hover className="fs--2 mb-0 align-middle">
                            <thead className="bg-200 text-800">
                                <tr>
                                    <th>Empresa (UUID)</th>
                                    <th>Servidor / BD</th>
                                    <th>Estatus</th>
                                    <th>Detalle / Motivo</th>
                                </tr>
                            </thead>
                            <tbody>
                                {progresoBorrado.empresas.length === 0 ? (
                                    <tr>
                                        <td colSpan="4" className="text-center py-3 text-muted">
                                            {progresoBorrado.enProgreso ? (
                                                <>
                                                    <Spinner animation="border" size="sm" className="me-2" />
                                                    Cargando empresas a procesar...
                                                </>
                                            ) : (
                                                'No hay registro de empresas procesadas en este ciclo.'
                                            )}
                                        </td>
                                    </tr>
                                ) : (
                                    progresoBorrado.empresas.map((emp, idx) => (
                                        <tr key={emp.uuidEmpresa || emp.idLicencia || idx}>
                                            <td>
                                                <div className="font-monospace fw-semi-bold text-truncate text-900" style={{ maxWidth: '170px' }}>
                                                    {emp.uuidEmpresa}
                                                </div>
                                                <div className="text-muted fs--2">Licencia: {emp.idLicencia}</div>
                                            </td>
                                            <td>
                                                <div className="fw-semi-bold text-900">{emp.servidor}</div>
                                                <div className="text-muted">{emp.baseDatos}</div>
                                            </td>
                                            <td>
                                                {emp.estatus === 'Borrando...' ? (
                                                    <Badge bg="primary" className="d-inline-flex align-items-center gap-1">
                                                        <Spinner animation="border" size="sm" style={{ width: '10px', height: '10px' }} />
                                                        <span>Borrando...</span>
                                                    </Badge>
                                                ) : emp.estatus === 'Exitoso' || emp.estatus === 'Borrado exitoso' || emp.exitoso === true ? (
                                                    <Badge bg="success">
                                                        <i className="fas fa-check me-1 fs--2"></i>Borrado
                                                    </Badge>
                                                ) : emp.estatus === 'Fallido' || emp.exitoso === false ? (
                                                    <Badge bg="danger">
                                                        <i className="fas fa-times me-1 fs--2"></i>Error
                                                    </Badge>
                                                ) : (
                                                    <Badge bg="secondary">
                                                        <i className="fas fa-clock me-1 fs--2"></i>En cola
                                                    </Badge>
                                                )}
                                            </td>
                                            <td>
                                                <div className="text-700" style={{ maxWidth: '280px', wordBreak: 'break-word' }}>
                                                    {emp.motivo || (emp.estatus === 'Borrando...' ? 'Ejecutando procedimiento de borrado en BD...' : 'Pendiente de procesar')}
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </Table>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer className="bg-100 border-top border-300 d-flex justify-content-between align-items-center">
                <small className="text-muted fs--2">
                    {progresoBorrado.enProgreso ? 'Puedes cerrar esta ventana; el proceso continuará ejecutándose en segundo plano.' : 'Proceso completado.'}
                </small>
                <Button 
                    variant={progresoBorrado.enProgreso ? "outline-secondary" : "primary"} 
                    size="sm" 
                    onClick={() => setProgresoBorrado(prev => ({ ...prev, show: false, ...(prev.enProgreso ? {} : { completado: false }) }))}
                >
                    {progresoBorrado.enProgreso ? 'Minimizar' : 'Entendido'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalProgresoBorrado;
